export const routeConstants = {
	CHARACTER: 'character',
	CHAT: 'chat',
	HISTORY: 'history',
	ERROR: 'error',
	AUTH: 'auth',
	API: 'api',
} as const;
